export const clientCode: string="HOOPPEMPLOYER";